'use strict';

export default class CtaFooterInjected {
    constructor() {
        this.name = 'cta-footer-injected';
        // console.log('%s module', this.name.toLowerCase());

        let $html = `
            <div class="views-field views-field-field-cta-footer js-injected">
            <div class="field-content">
                    <div class="theme-standard paragraph paragraph--type--cta-footer paragraph--view-mode--default">
                        <div class="row">
                        </div>
                    </div>
                </div>
            </div>
        `;

        if ($('.path-map').length || $('.path-calendar').length) {
            $('.layout-container footer').before($html);
        }
    }
}
